export function Pie() {
  return (
    <footer className="pie">
      <p>
        Reservas con{' '}
        <a href="https://holaturnos.com" target="_blank" rel="noopener noreferrer">
          HolaTurnos
        </a>
      </p>
    </footer>
  );
}
